import { Tooltip as ToolTipBT, OverlayTrigger } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import "./tooltip.scss";

export interface IProps {
  delay: number,
  direction: any, // eslint-disable-line
  content: string,
  children?: React.ReactNode;
  show?: boolean;
}

const Tooltip = ({children, direction, show, delay, content}: IProps) => {
  const tooltip = (
    <ToolTipBT className="mytooltip" id="tooltip">
      {content}
    </ToolTipBT>
  );

  return (
    <div className="toolTipInline">     
      <OverlayTrigger show={show && show} trigger={["hover", "hover"]} delay={{ show: delay? delay : 350, hide: 250}} placement={direction? direction : "top"} overlay={tooltip}>
        {children ? <div>{children}</div> : <div className="toolTipInline circle"><AiOutlineInfoCircle style={{ fontSize: "15px", verticalAlign: "top", cursor: "pointer" }}/></div>}
      </OverlayTrigger>
    </div>
  );
};

export default Tooltip;
